import styled from 'styled-components'

import { mainColors, semanticColors } from '@avantstay/backoffice-core'

export const Root = styled.form`
  width: min(100%, 52ch);
  padding: 8px;
  border-radius: 12px 4px 12px 12px;
  background: ${semanticColors.warningExtraLight};
  border: 1px solid ${semanticColors.warningLight};

  & textarea {
    resize: none;
    background-color: ${mainColors.white};
  }
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;

  & > button {
    width: auto;
  }
`
